import { getNextMultiSelectValue } from '../../Form'
import { LabelMultiSelect } from '../../Label'
import { useInitiallyOpenSelect } from '../../Select'

import { useProfileLabelsWidgetCreateLabel } from './ProfileLabelsWidgetForm.hooks'
import { getLabelsValueWithCreatedLabel } from './ProfileLabelsWidgetForm.utils'

import * as styles from './ProfileLabelsWidgetForm.module.css'

function ProfileLabelsWidgetForm({
  entity,
  fieldName,
  getPayload,
  initialValues,
  placeholder,
  onClose,
  onSubmit,
}) {
  const value = initialValues[fieldName]

  const selectStatesRef = useInitiallyOpenSelect()

  async function handleSubmitLabels({ nextValue, successTitle }) {
    try {
      await onSubmit(getPayload({ [fieldName]: nextValue }), successTitle)
    } catch {
      // the error notification is shown by the profile's update handler
    }
  }

  function handleAddCreatedLabel(createdLabel) {
    handleSubmitLabels({
      nextValue: getLabelsValueWithCreatedLabel(value, createdLabel),
      successTitle: null,
    })

    onClose()
  }

  const { createLabelModal, labelSelectListProps, skipCloseDropdownRef } =
    useProfileLabelsWidgetCreateLabel({
      entity,
      onAddCreatedLabel: handleAddCreatedLabel,
      onClose,
    })

  function handleSelectItem(option) {
    handleSubmitLabels({ nextValue: getNextMultiSelectValue(value, option) })
  }

  function handleCloseDropdown() {
    if (skipCloseDropdownRef.current) {
      skipCloseDropdownRef.current = false

      return
    }

    onClose()
  }

  return (
    <div className={styles.formFieldsWrapper}>
      <LabelMultiSelect
        Tags={null}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder,
            },
          },
        }}
        entity={entity}
        listProps={labelSelectListProps}
        selectStatesRef={selectStatesRef}
        value={value}
        onCloseDropdown={handleCloseDropdown}
        onSelectItem={handleSelectItem}
      />
      {createLabelModal}
    </div>
  )
}

export default ProfileLabelsWidgetForm
